import { useContext } from "react";
import { AppContext } from "../App";
import { formatDate, formatMoney } from "../Helpers";
import { MdArrowOutward } from "react-icons/md";

export default function One({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "sale-options",
      extraItem: data.uuid,
    });
  }

  return (
    <div className="entity-card" onClick={view}>
      <div className="entity-card-main">
        <div className="entity-card-title-row">
          <h6 className="entity-card-title">{data.model}</h6>
          <div className="entity-card-chip-row">
            <span className={`status-pill ${data.saleType === "loan" ? "status-pill-warning" : "status-pill-success"}`}>
              {data.saleType}
            </span>
            {data.status ? <span className="status-pill status-pill-primary">{data.status}</span> : ""}
          </div>
        </div>

        <div className="entity-card-meta-grid">
          <span>{data.fullname}</span>
          <span>{formatMoney(data.price)}</span>
          <span>Created {formatDate(data.dateCreated)}</span>
        </div>
      </div>

      <div className="entity-card-end">
        <MdArrowOutward />
      </div>
    </div>
  );
}
